import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { Leaderboard } from 'challenge/module/modules/visualisations/types';
import { state } from 'app/pwa/app.cerebral';

import { Name, Label, Image } from './elements';
import { getIndicatorConfig } from 'utils/common';
import { useImage, useFormatNumber } from 'common/hooks';

type Props = {
  readonly leaderboardUnit: Leaderboard;
  readonly size: string;
};

const deps = {
  indicator: state.challenge.campaign.indicator,
};

function PodiumData({
  leaderboardUnit,
  indicator,
  size,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const formatNumber = useFormatNumber();
  const [url, isLoading] = useImage(leaderboardUnit.avatarLarge);
  const { icon, color, precision } = getIndicatorConfig(indicator);

  return (
    <>
      <Image
        url={url}
        isLoading={isLoading}
        color={leaderboardUnit.avatarColor}
        size={size}
        name={leaderboardUnit.name}
      />
      <Name>{leaderboardUnit.name}</Name>
      <Label icon={icon} color={color}>
        {formatNumber(leaderboardUnit.value, precision)}
      </Label>
    </>
  );
}

export default connect<Props, typeof deps>(deps, PodiumData);
